import { createStore } from 'satcheljs';
import TextMessagingAccount from 'owa-service/lib/contract/TextMessagingAccount';

export default createStore('owaTextMessaging', {
    isHidden: true,
    textMessagingAccount: null as TextMessagingAccount,
});
